import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { anyToHash, filtersToQueryParams } from "utils/misc";

export default function useProducts(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProducts() {
      setLoading(true);
      const { response, data } = await API.fetchProducts(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    fetchProducts();
  }, [anyToHash(filters)]);

  return {
    loading,
    products: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.limit ?? 0,
  };
}
